export default "__VITE_ASSET__BPaaZpm1__"